<div class="task-management-container" *ngIf="!isLabelsLoading">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'management' }" (click)="selectedTab = 'management'; clearInputs(false)">{{
			labels.lbl_geral_pesquisar
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'create' }" (click)="selectedTab = 'create'; clearInputs(true)">{{
			labels.lbl_gerenciamento_de_tarefas
		}}</span>
	</div>

	<div class="body-wrap" *ngIf="selectedTab === 'management'">
		<div class="container">
			<span class="title">{{ labels.lbl_geral_pesquisar }}</span>

			<pcp-request-classification-reverse-rmk
				[alertField]="classificationOptions.alertField"
				[idCustomerList]="classificationOptions.selectedCustomer"
				(getClassification)="prepareReverseFilters($event)"
				*ngIf="filter.serviceType !== 'Problem' && filter.serviceType !== 'Complaint'">
			</pcp-request-classification-reverse-rmk>

			<ng-container *ngIf="filter.serviceType === 'Problem' || filter.serviceType === 'Complaint'">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_grupo }}</span>
					<select [(ngModel)]="filter.solutionArea">
						<option value="" [selected]="!filter.solutionArea">{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let solutionArea of solutionAreas" [value]="solutionArea.solutionArea">
							{{ solutionArea.solutionArea }}
						</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_chamado_tipo_servico }}</span>
					<select [(ngModel)]="filter.serviceType">
						<option *ngFor="let option of serviceTypeFilterOptions" [value]="option.label">{{ option.label }}</option>
					</select>
				</div>

				<div class="dotted-input-container" *ngIf="filter.serviceType !== 'Complaint'">
					<span>{{ labels.lbl_geral_severidade }}</span>
					<select [(ngModel)]="filter.severity">
						<option value="" [selected]="!filter.severity">{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let severity of severities" [value]="severity.severity">{{ severity.severity }}</option>
					</select>
				</div>
			</ng-container>

			<div class="button-container">
				<div class="button" (click)="getGroupTasks(true)">{{ labels.lbl_geral_pesquisar }}</div>
			</div>
		</div>

		<cpi-dot-bounce-loading-effect
			class="mt-2 ml-2"
			*ngIf="isDataLoading"
			[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
		<div
			*ngIf="
				!isDataLoading &&
				tasks.length > 0 &&
				(filter.serviceType || filter.solutionArea || filter.scope || filter.category || filter.topic || filter.nameTask)
			">
			<cpi-msp-table
				[header]="searchHeader"
				[body]="tasks"
				[height]="'35dvh'"
				[itemPadding]="'1%'"
				[labels]="labels"
				[insideSort]="true"
				(getSelectedItem)="openUpdatedForm($event[0])">
			</cpi-msp-table>
		</div>
	</div>

	<div class="body-wrap" *ngIf="selectedTab === 'create'">
		<div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_chamado_tipo_servico }}</span>
				<select [(ngModel)]="tasks[0].serviceType" (change)="onServiceTypeChange($event)" id="serviceType" name="serviceType">
					<option *ngFor="let option of serviceTypeOptions" [value]="option.value">{{ option.label }}</option>
				</select>
			</div>

			<cpi-dot-bounce-loading-effect
				class="mt-2 ml-2"
				*ngIf="isSolutionAreaLoading"
				[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
			<div class="dotted-input-container" *ngIf="!isSolutionAreaLoading">
				<span>{{ labels.lbl_geral_grupo }}</span>
				<select [(ngModel)]="tasks[0].solutionAreaMock" name="solutionArea">
					<option value="" [selected]="!tasks[0].solutionAreaMock">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let solutionArea of solutionAreasByServiceType" [value]="solutionArea.id">
						{{ solutionArea.solutionArea }}
					</option>
				</select>
			</div>

			<cpi-dot-bounce-loading-effect
				class="mt-2 ml-2"
				*ngIf="isScopeLoading"
				[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
			<div
				class="dotted-input-container"
				*ngIf="
					!isScopeLoading &&
					scopesOptions?.length > 0 &&
					(serviceType === 'Service Request' || serviceType === 'Change' || serviceType === 'Incident')
				">
				<span>{{ labels.lbl_geral_competencia }}</span>
				<select [(ngModel)]="tasks[0].scope" name="scope" (change)="loadCategory($event.target.value)">
					<option value="" [selected]="!tasks[0].scope">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let item of scopesOptions" [value]="item.id">{{ item.scope }}</option>
				</select>
			</div>

			<cpi-dot-bounce-loading-effect
				class="mt-2 ml-2"
				*ngIf="isCategoryLoading"
				[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
			<div
				class="dotted-input-container"
				*ngIf="
					!isCategoryLoading &&
					categoriesOptions?.length > 0 &&
					(serviceType === 'Service Request' || serviceType === 'Change' || serviceType === 'Incident')
				">
				<span>{{ labels.lbl_asset_category }}</span>
				<select [(ngModel)]="tasks[0].category" name="category" (change)="loadTopic($event.target.value)">
					<option value="" [selected]="!tasks[0].category">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let item of categoriesOptions" [value]="item.id">{{ item.category }}</option>
				</select>
			</div>

			<cpi-dot-bounce-loading-effect
				class="mt-2 ml-2"
				*ngIf="isTopicLoading"
				[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
			<div
				class="dotted-input-container"
				*ngIf="
					!isTopicLoading &&
					topicsOptions?.length > 0 &&
					(serviceType === 'Service Request' || serviceType === 'Change' || serviceType === 'Incident')
				">
				<span>{{ labels.lbl_geral_topico }}</span>
				<select [(ngModel)]="tasks[0].topic" name="topic">
					<option value="" [selected]="!tasks[0].topic">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let item of topicsOptions" [value]="item.id">{{ item.topic }}</option>
				</select>
			</div>

			<div class="dotted-input-container" *ngIf="serviceType === 'Problem' || serviceType === 'Incident'">
				<span>{{ labels.lbl_geral_severidade }}</span>
				<select [(ngModel)]="tasks[0].severity" name="severityForTemplate">
					<option value="" [selected]="!tasks[0].severity">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let severity of severities" [value]="severity.severity">{{ severity.severity }}</option>
				</select>
			</div>
		</div>

		<div class="dotted-input-container" *ngIf="!isTemplateLoading">
			<span>Template</span>
			<select [(ngModel)]="tasks[0].template" name="template">
				<option value="0" [selected]="">{{ labels.lbl_geral_selecione }}</option>
				<option *ngFor="let template of templates" [value]="template.id">{{ template.template }}</option>
			</select>
		</div>

		<div *ngIf="tasks && tasks.length > 0">
			<div class="task-container" *ngIf="tasks[0]?.template == 0 || tasks[0]?.template === ''">
				<div *ngFor="let task of tasks; let i = index" class="task-card">
					<div class="task-header">
						<span *ngIf="task.taskId !== 0 || task.task !== ''">{{ task.taskId }} - {{ task.task }}</span>
						<span *ngIf="task.taskId === 0 || task.task === ''"> </span>
						<div class="task-actions">
							<button (click)="toggleTask(i)">
								<fa-icon [icon]="task.expanded ? icons.faChevronUp : icons.faChevronDown"></fa-icon>
							</button>
							<button (click)="removeTask(i)"><fa-icon [icon]="icons.faTrash"></fa-icon></button>
						</div>
					</div>
					<div *ngIf="task.expanded" class="task-content">
						<form>
							<div class="dotted-input-container">
								<span>{{ labels.lbl_id_tarefa }}*</span>
								<input
									type="text"
									[(ngModel)]="task.taskId"
									name="taskId{{ i }}"
									placeholder="{{ labels.lbl_id_tarefa }}" />
							</div>

							<div class="dotted-input-container">
								<span>{{ labels.lbl_chamado_tarefa }}*</span>
								<input
									type="text"
									[(ngModel)]="task.task"
									name="task{{ i }}"
									placeholder="{{ labels.lbl_chamado_tarefa }}" />
							</div>

							<div class="dotted-input-container">
								<span>{{ labels.lbl_geral_predecessores }}*</span>
								<input
									type="text"
									[(ngModel)]="task.predecessor"
									name="predecessor{{ i }}"
									placeholder="{{ labels.lbl_geral_predecessores }}" />
							</div>

							<div class="dotted-input-container">
								<span>{{ labels.lbl_geral_tipo }}*</span>
								<select [(ngModel)]="task.type" name="type{{ i }}" (change)="onTypeChange(task, i)">
									<option value="" [selected]="!task.type">{{ labels.lbl_geral_selecione }}</option>
									<!-- Solução provisoria para incidente porque não tem classificação e está enviando area de solução vazia -->
									<option *ngIf="task.serviceType !== 'Incident'" value="Authorization">Authorization</option>
									<option value="Execution">Execution</option>
									<option value="Execution - SubRequest">Execution - SubRequest</option>
									<option *ngIf="task.serviceType !== 'Incident'" value="Review">Review</option>
								</select>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Execution - SubRequest' || task.type === 'Execution'">
								<span>{{ labels.lbl_geral_grupo }}*</span>
								<select
									[(ngModel)]="task.solutionAreaId"
									name="solutionArea{{ i }}"
									(change)="onSolutionAreaChange(task, i)">
									<option value="" [selected]="!task.solutionAreaId">{{ labels.lbl_geral_selecione }}</option>
									<option *ngFor="let solutionArea of solutionAreas" [value]="solutionArea.id">
										{{ solutionArea.solutionArea }}
									</option>
								</select>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Execution - SubRequest' || task.type === 'Execution'">
								<span>{{ labels.lbl_geral_analista }}*</span>
								<select [(ngModel)]="task.analyst" name="analyst{{ i }}">
									<option value="0" [selected]="!task.analyst">{{ labels.lbl_geral_selecione }}</option>
									<option *ngFor="let analyst of task.analysts" [value]="analyst.id">{{ analyst.full_name }}</option>
								</select>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Authorization' || task.type === 'Review'">
								<span>{{ labels.lbl_grupo_aprovadores_revisores }}</span>
								<select
									[(ngModel)]="task.group"
									name="group{{ i }}"
									(ngModelChange)="onSelectChange(task)"
									[disabled]="disableSelect">
									<option value="0" [selected]="!task.group">{{ labels.lbl_geral_selecione }}</option>
									<option *ngFor="let group of approversGroups" [value]="group.value">{{ group.name }}</option>
								</select>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Authorization' || task.type === 'Review'">
								<span>{{ labels.lbl_geral_enduser_approval }}</span>
								<cpi-checkbox
									[value]="task.enduserApproval"
									(oValue)="onCheckboxChange(task, 'enduserApproval', $event)"
									[innerText]="task.enduserApproval == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao"
									[disable]="disableCheckbox">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Authorization' || task.type === 'Review'">
								<span>{{ labels.lbl_supervisor }}</span>
								<cpi-checkbox
									[value]="task.enduserSupervisor"
									(oValue)="onCheckboxChange(task, 'enduserSupervisor', $event)"
									[innerText]="task.enduserSupervisor == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao"
									[disable]="disableCheckbox1">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container">
								<span>{{ labels.lbl_chamado_tarefa_requerida }}</span>
								<cpi-checkbox
									[value]="task.required"
									(oValue)="task.required = $event"
									[innerText]="task.required == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Execution - SubRequest' || task.type === 'Execution'">
								<span>Waiting Finish (Customer IT)</span>
								<cpi-checkbox
									[value]="task.waitingFinish"
									(oValue)="task.waitingFinish = $event"
									[innerText]="task.waitingFinish == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container" *ngIf="task.type === 'Execution - SubRequest' || task.type === 'Execution'">
								<span>{{ labels.lbl_anexo_obrigatorio }}</span>
								<cpi-checkbox
									[value]="task.uploadRequired"
									(oValue)="task.uploadRequired = $event"
									[innerText]="task.uploadRequired == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container" *ngIf="task.serviceType === 'Change'">
								<span>{{ labels.lbl_geral_change_urgente }}</span>
								<cpi-checkbox
									[value]="task.urgentChange"
									(oValue)="task.urgentChange = $event"
									[innerText]="task.urgentChange == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
								</cpi-checkbox>
							</div>

							<div class="dotted-input-container">
								<span>{{ labels.lbl_geral_descricao }}</span>
								<textarea [(ngModel)]="task.description" name="description{{ i }}"></textarea>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<div class="button-container">
			<div class="button" (click)="addTask()" *ngIf="!tasks[0].template"><fa-icon [icon]="icons.faPlus"></fa-icon></div>
			<div class="button" (click)="saveTasks()">{{ labels.lbl_geral_salvar }}</div>
			<div class="button" *ngIf="tasks[0].template" (click)="removeTaskTemplate(tasks[0])">{{ labels.lbl_geral_excluir }}</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect class="mt-2 ml-2" *ngIf="isLabelsLoading" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
